import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function SmackPartner() {
  return (
    <section className="partner_smack">
      <Container>
        <Row>
          <Col
            xs={12}
            md={4}
            lg={3}
            xl={3}
            className="my-auto text-center order-md-1 order-2"
          >
            <div className="partner_img">
              <StaticImage
                src="../../../images/case-studies/smackback/mobile.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={474}
                height={864}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            className="my-auto offset-lg-1 order-md-2 order-1"
          >
            <h2>Tekrevol – Your Partner in Mobile App Development</h2>
            <p>
              With an extensive range of tech solutions, we are more than just
              an Android and iPhone app development company. Since the moment
              our clients join us to developing, launching, maintaining, and
              continuously innovating the app, our team is available to you
              guide you throughout the journey.
            </p>
            <p>
              Our top mobile app development experts make sure that every app we
              design and develop incorporate the most advanced development
              practices and adherence to global standards. We are also known to
              integrate our apps with emerging technologies like artificial
              intelligence, machine learning, and augmented reality, taking
              automation to the next level.
            </p>
            <p>
              If you have an app idea, and you want guidance on how to get your
              app ready for the real world, we would be more than happy to
              assist you.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SmackPartner;
